import { LanguageCode } from "common/types/languageCode";

export const isRtl = (language: LanguageCode) => language === LanguageCode.AR;
